import { useEffect } from "react";
import { WebinarsPlayer } from "./components/WebinarsPlayer";
import { linksConstants } from "../../../constants/linksConstants";
import { BottomCTA } from "../components/ui/BottomCTA";
import { useRouter } from "next/router";
import { slugify } from "../../../utils/slugify";

export const WebinarsVideo = ({ butterData, videoData, webinarDataset }) => {
  const router = useRouter();
  useEffect(() => {
    const generatedPath = `${linksConstants.WEBINARS_VIDEO_SLUGIFIED.split("/:")[0]}/${
      videoData.video_actual.split("/").reverse()[0]
    }--${slugify(videoData.title)}`;

    router.asPath !== generatedPath && router.replace(generatedPath, undefined, { shallow: true });
  }, [videoData]);

  return (
    <section className="webinars_video">
      <div className="webinars_video-hero">
        <div className="section-layout">
          {butterData.webinars && (
            <>
              <WebinarsPlayer data={videoData} />
            </>
          )}
        </div>
      </div>
      <BottomCTA data={webinarDataset.bottomCTA} unskewed />
    </section>
  );
};
